import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=5e72edbe&scoped=true"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"
import style0 from "./CategorySection.vue?vue&type=style&index=0&id=5e72edbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72edbe",
  null
  
)

export default component.exports